import React from "react";
import "./termsCondition.scss";
import ContactForm from "../../common-ui/contact-form/ContactForm";
import { Link } from "react-router-dom";

const TermsAndConditions: React.FC = () => {
  return (
    <div className="terms-and-conditions">
      <div className="container">
        <header className="terms-header">
          <h1>Terms and Conditions of Website Use</h1>
        </header>

        <div className="terms-columns">
          {/* Left Column - Content */}
          <main className="terms-content">
            <section className="terms-section">
              <h2>1. General</h2>
              <p>
                This website is the exclusive property of Hot Freight
                International (“Hot Freight International”). By accessing and
                using this site, you agree to these terms and conditions. If you
                do not agree, please discontinue use immediately. Your continued
                use of the site confirms your acceptance of these terms and all
                applicable laws.
              </p>
            </section>

            <section className="terms-section">
              <h2>2. Compliance with Laws</h2>
              <p>
                You agree to use this site in accordance with these terms and
                all applicable laws, including those related to copyright,
                trademarks, and intellectual property.
              </p>
            </section>

            <section className="terms-section">
              <h2>3. Intended Use and Web Etiquette</h2>
              <p>
                Your use of this site must align with Hot Freight International’s
                intended purpose for making it available and with generally
                accepted online etiquette.
              </p>
            </section>

            <section className="terms-section">
              <h2>4. Monitoring</h2>
              <p>
                We may monitor your use of the website and that of other users
                at our sole discretion. By using this site, you consent to such
                monitoring, though we are under no obligation to do so.
              </p>
            </section>

            <section className="terms-section">
              <h2>5. Access Restrictions</h2>
              <p>
                We reserve the right to limit or deny access to the site at our
                discretion and without notice.
              </p>
            </section>

            <section className="terms-section">
              <h2>6. Purpose and Accuracy of Information</h2>
              <p>
                This site provides information about Hot Freight International
                and its products, services, and affiliates. While we strive to
                keep content accurate and current, it may contain errors,
                omissions, or outdated details. Verify important information
                through an alternative source or by contacting us directly.
              </p>
            </section>

            <section className="terms-section">
              <h2>7. Limitation of Liability</h2>
              <p>
                We make no warranties, express or implied, about the accuracy,
                reliability, or operation of this site. We are not liable for
                any loss, damage, or issues arising from its use.
              </p>
            </section>

            <section className="terms-section">
              <h2>8. Your Responsibility</h2>
              <p>
                You are responsible for any damages resulting from misuse of the
                site that violates these terms or applicable laws. You agree to
                indemnify Hot Freight International against any claims or
                liabilities arising from such misuse.
              </p>
            </section>

            <section className="terms-section">
              <h2>9. Copyright</h2>
              <p>
                All content on this site is protected by copyright. Any use
                beyond personal, non-commercial purposes requires prior written
                consent from Hot Freight International. All trademarks, logos,
                and names are owned by Hot Freight International and may not be
                used without permission.
              </p>
            </section>

            <section className="terms-section">
              <h2>10. External Links</h2>
              <p>
                This site may contain links to third-party websites for your
                convenience. We do not endorse or control these sites and are
                not responsible for their content or any issues arising from
                their use. Linking to our site requires prior written approval.
              </p>
            </section>

            <section className="terms-section">
              <h2>11. Privacy Policy</h2>
              <p>
                Your use of this site is also subject to our{" "}
                <Link to="/privacy-policy">Online Privacy Policy</Link>, which is
                part of these terms.
              </p>
            </section>

            <section className="terms-section">
              <h2>12. Non-Confidential Information</h2>
              <p>
                Any information submitted through this site is considered
                non-confidential unless otherwise stated. We may use it without
                limitation.
              </p>
            </section>

            <section className="terms-section">
              <h2>13. Data Exchange</h2>
              <p>
                By using this site, you consent to the exchange of data between
                your device and our servers. We may store and use certain data
                internally, disclosing it only when legally required.
              </p>
            </section>

            <section className="terms-section">
              <h2>14. Cookies</h2>
              <p>
                Our site may use cookies to improve your experience. You can
                disable cookies in your browser settings, but continued use of
                the site without doing so implies consent to their use.
              </p>
            </section>

            <section className="terms-section">
              <h2>15. Changes</h2>
              <p>
                We may update these terms or modify the site at any time without
                prior notice. The version in effect at the time of any dispute
                will apply.
              </p>
            </section>

            <section className="terms-section">
              <h2>16. Jurisdiction</h2>
              <p>
                All disputes related to this site fall under the exclusive
                jurisdiction of the courts in Ontario, Canada.
              </p>
            </section>

            <section className="terms-section">
              <h2>17. Governing Law</h2>
              <p>
                These terms are governed by the laws of Ontario, without regard
                to conflict-of-law rules.
              </p>
            </section>

            <section className="terms-section">
              <h2>18. Territory</h2>
              <p>
                This site is operated in Canada. If you access it from outside
                Canada, you do so at your own risk and must comply with local
                laws.
              </p>
            </section>

            <section className="terms-section">
              <h2>19. Interpretation</h2>
              <p>
                References to “Hot Freight International” include its
                subsidiaries, divisions, and affiliates. References to “this
                website” include all related pages and subdomains operated by
                us.
              </p>
            </section>
          </main>

          {/* Right Column - Form */}
          <aside className="terms-form">
            <div className="form-container">
              <h2 className="form-heading">Have Questions About Our Terms?</h2>
              <p className="form-subheading">
                Contact our legal team for clarification.
              </p>
              <ContactForm />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
